import productAPI from '@/api/products'
import sortingAPI from '@/api/products/sorting'
import { HttpFunctions } from '@/api/http-functions'

export const searchProducts = ({ dispatch, commit, state }, productSearch) => {
  return new Promise((resolve, reject) => {
    if (productSearch !== '') {
      commit('setProductSearch', productSearch)
    }
    dispatch('getQueryString').then(queryString => {
      commit('setIsSearchLoading', true)
      productAPI.getProducts(result => {
        commit('setProducts', result)
        commit('setIsSearchLoading', false)
        resolve()
      }, queryString)
    })
  })
}

export const searchProductUnderCategory = ({ dispatch, commit, state }, productSearch) => {
  return new Promise((resolve, reject) => {
    if (productSearch !== '') {
      commit('setProductSearch', productSearch)
    }
    dispatch('getQueryString').then(queryString => {
      productAPI.getProductsUnderCategory(result => {
        commit('setProductsUnderCategory', result)
        resolve()
      }, queryString)
    })
  })
}

export const getQueryString = ({ state }) => {
  let queryString = '?'
  queryString += '_page=' + state.search.page
  queryString += '&_limit=' + state.search.limit
  queryString += '&_sort=' + state.search.sort
  queryString += '&_order=' + state.search.order
  queryString += '&keyword=' + encodeURIComponent(state.search.keyword)
  if (state.search.priceStatus) {
    queryString += '&priceType=' + state.search.priceType
    queryString += '&price1=' + state.search.price1
    if (state.search.priceType === 'between') {
      queryString += '&price2=' + state.search.price2
    }
  }
  if (state.search.stockStatus) {
    queryString += '&stockType=' + state.search.stockType
    queryString += '&stock1=' + state.search.stock1
    if (state.search.stockType === 'between') {
      queryString += '&stock2=' + state.search.stock2
    }
  }
  queryString += '&category_id=' + state.search.categoryId
  if (state.search.productStatus) {
    queryString += '&status=' + state.search.productStatusType
  }
  if (state.search.productLabel) {
    queryString += '&label=' + state.search.productLabelType
  }
  return queryString
}

export const resetProductSearch = ({ dispatch }) => {
  let searchInit = {
    page: 1,
    limit: 10,
    sort: 'id',
    order: 'desc',
    keyword: '',
    priceStatus: false,
    priceType: 'between',
    price1: '1',
    price2: '1000',
    stockStatus: false,
    stockType: 'between',
    stock1: '1',
    stock2: '1000',
    categoryId: 0,
    productStatus: false,
    productStatusType: 'show',
    advanceSearch: false,
    searchInputClear: false,
    productLabel: false,
    productLabelType: '1',
    isSearch: false,
    countSearchFilter: 0,
    isSearchLoading: false
  }
  dispatch('searchProducts', searchInit)
}

export const deleteProductAPI = ({ dispatch }, param) => {
  return new Promise((resolve, reject) => {
    productAPI.deleteProduct(result => {
      dispatch('searchProducts', '')
      param.success()
      resolve(result)
    }, param.productId)
  })
}

export const getProductImagesAPI = ({ commit, dispatch }, productId) => {
  return new Promise((resolve, reject) => {
    productAPI.getProductImages(productId, result => {
      commit('setCurrentProductImageLimit', result.data.data.imagesLimit)
      commit('setCurrentProductImagesCount', result.data.data.image.length)
      resolve(result.data.data.image)
    })
  })
}

export const uploadProductImageAPI = ({commit}, formData) => {
  return new Promise((resolve, reject) => {
    productAPI.uploadProductImage(formData, result => {
      resolve(result.data.data)
    })
  })
}

export const getVelaeasySectionsProductAPI = ({ commit }, productId) => {
  return new Promise((resolve, reject) => {
    productAPI.getVelaeasySections(result => {
      resolve(result.data.data)
    }, productId)
  })
}

export const getCountAllProducts = ({ commit }) => {
  return new Promise((resolve, reject) => {
    productAPI.getCountAllProducts(result => {
      commit('setCountAllProducts', result.data.data.count)
      HttpFunctions.setCountAllProducts(result.data.data.count)
      resolve(result.data.data)
    })
  })
}

export const getProductsSortingOptions = ({ commit }, categoryId) => {
  return new Promise((resolve, reject) => {
    sortingAPI.getProductsSortingOptions(categoryId, results => {
      if (results.data.status === 'success') {
        resolve(results.data.data)
      } else {
        reject()
      }
    })
  })
}

export const getProductsSortingList = ({ commit }, params) => {
  return new Promise((resolve, reject) => {
    sortingAPI.getProductsSortingList(params, results => {
      if (results.data.status === 'success') {
        commit('setSortingProductEditKey', results.data.data.key)
        resolve(results.data.data)
      } else {
        reject()
      }
    })
  })
}

export const updateProductsSorting = ({ commit }, params) => {
  return new Promise((resolve, reject) => {
    sortingAPI.updateProductsSorting(params, results => {
      if (results.data.status === 'success') {
        commit('setSortingProductEditKey', results.data.data.key)
        resolve()
      } else {
        reject()
      }
    })
  })
}

export const updateProductsSortingBackend = ({ commit }, params) => {
  return new Promise((resolve, reject) => {
    sortingAPI.updateProductsSortingBackend(params, results => {
      if (results.data.status === 'success') {
        commit('setSortingProductEditKey', results.data.data.key)
        resolve()
      } else {
        reject()
      }
    })
  })
}

export const setProductSortingPin = ({ commit }, params) => {
  return new Promise((resolve, reject) => {
    sortingAPI.setProductSortingPin(params, results => {
      if (results.data.status === 'success') {
        resolve()
      } else {
        reject()
      }
    })
  })
}

export const deleteProductSortingPin = ({ commit }, params) => {
  return new Promise((resolve, reject) => {
    sortingAPI.deleteProductSortingPin(params, results => {
      if (results.data.status === 'success') {
        resolve()
      } else {
        reject()
      }
    })
  })
}

export const setProductsSortOption = ({ commit }, params) => {
  return new Promise((resolve, reject) => {
    sortingAPI.setProductsSortOption(params, results => {
      if (results.data.status === 'success') {
        resolve()
      } else {
        reject()
      }
    })
  })
}

export const updateProductImageAPI = ({commit}, formData) => {
  return new Promise((resolve, reject) => {
    productAPI.updateProductImage(formData, result => {
      resolve(result.data.data)
    })
  })
}

export const setProductTabSelected = ({ commit }, params) => {
  commit('setProductTabSelected', params)
}

export const getProductLabels = ({ commit }) => {
  return new Promise((resolve, reject) => {
    productAPI.getProductLabels(result => {
      resolve(result.data.data)
    })
  })
}

export const saveProductsSorting = ({ commit }, params) => {
  return new Promise((resolve, reject) => {
    sortingAPI.saveProductsSorting(params, results => {
      if (results.data.status === 'success') {
        commit('setSortingProductEditKey', results.data.data.key)
        resolve(results.data)
      } else {
        reject(new Error('Save product failed'))
      }
    })
  })
}

export const updateProductsSortingByTarget = ({ commit }, params) => {
  return new Promise((resolve, reject) => {
    sortingAPI.updateProductsSortingByTarget(params, results => {
      if (results.data.status === 'success') {
        resolve()
      } else {
        reject()
      }
    })
  })
}

export const checkProductSkuList = async ({ commit }, params) => {
  return new Promise(async (resolve, reject) => {
    try {
      const result = await productAPI.checkProductSkuList(params)

      if (result.data.status === 'success') {
        resolve(result.data.data)
      } else {
        reject(false)
      }
    } catch (error) {
      reject(error)
    }
  })
}



// WEBPACK FOOTER //
// ./src/store/modules/products/actions.js